import { useCallback, useReducer } from 'react';

import { DEFAULT_PAID_BREAK_BEHAVIOR } from '@careerstart/wae-common/schema/models/position-template/enums/paidBreakBehaviors';

export const INITIAL_VALUES = {
  corporation: null,
  name: '',
  industry: '',
  description: '',
  // Each location: { id, name, address, jurisdiction, compCode }
  locations: [],
  payRates: { reg: '', ot: '', dt: '' },
  billRates: { reg: '', ot: '', dt: '' },
  shifts: [],
  // Each item: the picked API document { _id, name }
  requirements: { certifications: [], skills: [] },
  additionalInfo: {
    requireEmployerApproval: false,
    allowBackfill: true,
    overtimeAllowed: true,
    isEnforcingAttendancePolicy: true,
    isPunchingOutsideOfShiftEnabled: false,
    isGPSEnforced: true,
    punchDistance: '200',
    earlyPunchWindow: 15,
    punchRounding: 1,
  },
  legalInfo: { paidBreakBehavior: DEFAULT_PAID_BREAK_BEHAVIOR },
};

const ACTIONS = {
  SET_FIELD: 'SET_FIELD',
  RESET: 'RESET',
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_FIELD:
      return { ...state, [action.field]: action.value };
    case ACTIONS.RESET:
      return INITIAL_VALUES;
    default:
      return state;
  }
};

const usePositionTemplateForm = (initialValues = INITIAL_VALUES) => {
  const [values, dispatch] = useReducer(reducer, initialValues);

  const setField = useCallback(
    (field, value) => dispatch({ type: ACTIONS.SET_FIELD, field, value }),
    []
  );

  const reset = useCallback(() => dispatch({ type: ACTIONS.RESET }), []);

  return { values, setField, reset };
};

export default usePositionTemplateForm;
